<template>
	<div id="chatinput">
		<form v-on:submit.prevent="noop">
			<img @error="onError" :src="'https://graph.facebook.com/'+ selectedBot.pageid +'/picture?width=100&height=100'" style="border-radius: 50%;width:35px;height:35px;margin-right:5px;border: 1px solid #eee;display: inline-block;vertical-align: top;margin-top: 5px; margin-left: 5px;">
			<autoresize-textarea v-model="text" rows="1" placeholder="Type message" style="resize: none;border: 0px; outline: 0px;background: none;    display: inline-block;"></autoresize-textarea>
			<!-- <textarea style="width:70%;border:none;resize: none;outline: none;padding:10px;float:left" placeholder="Type message" v-model="text" @keydown.enter.exact.prevent @keyup.enter.exact="sendMessage" @keydown.enter.shift.exact="newline"></textarea> -->
			<button class="btn btn-success" :disabled="!enableSend" style="float:right;margin:10px" @click="sendMessage" v-tooltip.top="'Send'">
				<i class="fa fa-send"></i>
			</button>
			
		</form>
	</div>
</template>

<script>
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import { mapGetters } from 'vuex'
import api from '@/api'

	export default{
		props: ['value','app'],
		data: function(){
			return {
				type: 'text',
				text: '',
				enableSend: false,
				user: this.value,
			}
		},
		computed: {
		    ...mapGetters({
		        selectedBot: 'selectedBot'
		    }),
		},
		components: {
			AutoresizeTextarea
		},
		methods: {
		    newline() {
		      this.text = '${this.text}\n';
			},
			onError: function(){
				$(event.target).attr('src','/static/img/assets/livechat/profile.png')
			},
			sendMessage : function(){
				let vm = this
				if (vm.enableSend == false || vm.selectedBot == null || vm.user == null) {
					return false;
				}
				let data = {
					pageid : vm.selectedBot.pageid,
					userid : vm.user.userid,
					app : vm.app,
					messagetype : vm.type,
					messagevalue : vm.text,
					page_access_token : vm.selectedBot.page_access_token
				}


				let message = {
					answerby: 'admin',
					id: (new Date()).getTime() ,
					messagedata:  vm.text,
					messagetype: vm.type,
					pageid: vm.selectedBot.pageid,
					timestamp: new Date(),
					userid: vm.user.userid,
				}
				vm.$emit('onSendMessage',message)
				vm.text = ''

				api.sendMessage(data,function(error, response){
					if (error) {
						console.error(error)
						// vm.$store.dispatch('loading')
						return
					}
					// vm.$store.dispatch('loading')
					
				})
			},
			noop () {
			// do nothing ?
			}
		},
		watch: {
			text: function(newVal, oldVal) {
				if (newVal != "") {
					this.enableSend = true
				} else {
					this.enableSend = false
				}
			},
			value: function(newVal, oldVal) {
				this.user = this.value
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatinput.vue